import creditCardType from "credit-card-type";
import { object, string } from "yup";
const currentYear = new Date().getFullYear();
const currentMonth = new Date().getMonth();

export const validationSchema = (t) =>
  object({
    cardHolderName: string().required(t("cardNameholder")),
    cardNumber: string()
      .matches(/^(?!.*[\u0660-\u0669])[0-9]{16}$/, t("telephoneError1"))
      .matches(/^\d{16}$/, t("cardNumberError"))
      .test(
        "card-number",
        t("InvalidCardNumber"),
        (value) => creditCardType(value).length > 0
      )
      .required(t("CardNumberRequired")),
    expirationMonth: string()
      .matches(/^(0[1-9]|1[0-2])$/, t("cardExpMonthError3"))
      .test(
        "expirationYear",
        t("cardExpMonthError2") + " " + currentMonth + 1,
        function (value) {
          const { expirationYear } = this.parent; // Access the expirationYear field value
          if (expirationYear === String(currentYear)) {
            return parseInt(value, 10) >= currentMonth;
          }
          return true;
        }
      )
      .required(t("cardExpMonthError1")),
    expirationYear: string()
      .matches(/^\d{4}$/, t("cardExpYearError"))
      .test(
        "expirationYear",
        t("cardExpMonthError") + " " + currentYear,
        (value) => {
          return parseInt(value, 10) >= currentYear;
        }
      )
      .required(t("cardExpYearError1")),
    ccv: string()
      .matches(/^(?!.*[\u0660-\u0669])[0-9]+$/, t("telephoneError1"))
      .matches(/^\d{3,4}$/, t("ccvError2"))
      .required(t("ccvError1")),
  });

export const mobileNumberValidation = (t) =>
  object().shape({
    mobile: string()
      .label("Phone number")
      .matches(/^(05)(5|0|3|6|4|9|1|8|7)([0-9]{7})$/, t("mobileError2"))
      .required(t("TelephoneRequired")),
  });
export const AddressValidation = (t) =>
  object().shape({
    firstname: string().trim().required(t("firstnameRequired")),
    lastname: string().trim().required(t("lastnameRequired")),
    email: string()
      .trim()
      .email(t("notValidEmail"))
      .required(t("emailRequired")),
    city: string().trim().required(t("cityRequired")),
    telephone: string()
      .matches(/^(05)(5|0|3|6|4|9|1|8|7)([0-9]{7})$/, t("telephoneError2"))
      .min(10, t("mobile can not be less 10 numbers"))
      .required(t("TelephoneRequired")),
    street: string()
      .trim()
      .required(t("streetRequired"))
      .min(10, t("street must be at least 10 characters")),
  });
